'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import { useState, useEffect } from 'react';

function delay(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, ms ? new Promise(function (resolve) { return setTimeout(resolve, ms); }) : Promise.resolve()];
        });
    });
}
function useDelay(ms, defaultSetting) {
    if (defaultSetting === void 0) { defaultSetting = true; }
    var _a = useState(defaultSetting), isDelay = _a[0], setIsDelay = _a[1];
    useEffect(function () {
        if (ms) {
            delay(ms).then(function () { return setIsDelay(!defaultSetting); });
        }
    }, [ms, defaultSetting]);
    return isDelay;
}

export { useDelay as default };
//# sourceMappingURL=useDelay.js.map
